/**
 * Contexte des gels (perf.gel) : ce qui s'est passé PENDANT un blocage de l'appli, pour
 * distinguer une suspension par le système (Android : volet de notifications, appel,
 * économie d'énergie — la page perd le focus sans être masquée) d'un calcul de l'appli
 * (rafraîchissement complet d'un gros rapport). Module sans dépendance : alimenté par
 * BiState et lu par PerformanceMonitorService, sans injection croisée.
 */

/** Rafraîchissements complets du rapport (biChange…) : instant et durée synchrone. */
const notifications: { t: number; ms: number }[] = [];
/** Pertes / reprises de focus de la fenêtre (performance.now). */
const focus: { t: number; gagne: boolean }[] = [];
let tailleDossier: () => Record<string, number> = () => ({});

export function noterNotification(debut: number, fin: number): void {
	notifications.push({ t: debut, ms: Math.round(fin - debut) });
	if (notifications.length > 30) notifications.splice(0, notifications.length - 30);
}

export function fournirTailleDossier(f: () => Record<string, number>): void {
	tailleDossier = f;
}

let suiviFocus = false;
function suivreFocus(): void {
	if (suiviFocus || typeof window === 'undefined') return;
	suiviFocus = true;
	const noter = (gagne: boolean) => () => {
		focus.push({ t: performance.now(), gagne });
		if (focus.length > 30) focus.splice(0, focus.length - 30);
	};
	window.addEventListener('blur', noter(false));
	window.addEventListener('focus', noter(true));
}
suivreFocus();

/** Attributs du gel survenu entre `debut` et `fin` (performance.now). */
export function contexteGel(debut: number, fin: number): Record<string, string | number | boolean> {
	const pendant = notifications.filter(n => n.t >= debut - 500 && n.t <= fin);
	const focusPendant = focus.filter(f => f.t >= debut - 1000 && f.t <= fin + 2000);
	const connexion: any = (navigator as any)?.connection;
	const attributs: Record<string, string | number | boolean> = {
		'gel.focus': typeof document !== 'undefined' && document.hasFocus(),
		'gel.focus_perdu': focusPendant.some(f => !f.gagne),
		'gel.focus_repris': focusPendant.some(f => f.gagne),
		'gel.notifications': pendant.length,
		'gel.notification_max_ms': pendant.reduce((m, n) => Math.max(m, n.ms), 0),
		'gel.notifications_ms': pendant.reduce((s, n) => s + n.ms, 0),
		'gel.en_ligne': typeof navigator !== 'undefined' ? navigator.onLine : true,
	};
	if (connexion?.effectiveType) attributs['gel.reseau'] = String(connexion.effectiveType);
	if (connexion?.saveData) attributs['gel.economie_donnees'] = true;
	try {
		for (const [cle, valeur] of Object.entries(tailleDossier())) attributs[`gel.dossier_${cle}`] = valeur;
	} catch { /* mesure seulement */ }
	return attributs;
}
